import { useState } from 'react'
import { API } from '../../../../api'
import { IQDialog, Preloader } from '../../../common'
import Button from '@mui/material/Button'
import { Stack, Typography } from '@mui/material'
import { trimAndReplaceWhiteSpaces } from '../../../../utility/string-format'
import { EntitiesTypes, getEntityTitle } from '../../../../view/admin/ad-management/EntitiesTabs'
import { getRightSufix } from './EntityGroupsUpdate'

interface IProps {
  isShow: boolean
  name: string
  description: string
  groups: string[]
  onSuccess: () => void
  onCancel: () => void
  type: EntitiesTypes
}

export const EntityGroupsCreate = ({ isShow, name, description, groups, onSuccess, onCancel, type }: IProps) => {
  const titleName = getEntityTitle(type)
  const [isLoading, setIsLoading] = useState(false)

  const handleSave = async () => {
    try {
      setIsLoading(true)
      await API.ADManagement.entities.create(name, trimAndReplaceWhiteSpaces(description), groups, getRightSufix(type))
      onSuccess()
    } catch (err) {
      console.log(err)
      onCancel()
    } finally {
      setIsLoading(false)
    }
  }

  const renderCreateActions = () => (
    <Stack
      direction='row'
      spacing={2}
      justifyContent='space-between'
      sx={{
        width: '100%',
      }}
    >
      <Button
        onClick={() => onCancel()}
        data-testid={`${type}-create-cancel`}
        variant='outlined'
      >
        Cancel
      </Button>

      <Button
        disabled={isLoading}
        variant='contained'
        onClick={handleSave}
        data-testid={`${type}-create-save`}
      >
        Save
      </Button>
    </Stack>
  )

  return (
    <IQDialog
      isShow={isShow}
      title={
        <Typography
          fontWeight={700}
          variant='h6'
        >
          {`Are you sure you want to create this ${titleName}?`}
        </Typography>
      }
      content={
        isLoading ? (
          <Preloader
            size='sm'
            style={{ display: 'block', margin: '0 auto' }}
          />
        ) : (
          false
        )
      }
      actions={renderCreateActions()}
      onClose={onCancel}
      testPrefix={`${type}-create`}
    />
  )
}
